module.exports = __webpack_public_path__ + "static/img/IMG_20161022_094428-EFFECTS.ce19515c.jpg";